<template>
    <DoctorFormComponent
        :button-titles="buttonTitles"
        :create-new-doctor="true"
        :escript-response-prescriber="prefill"
        :hosted="true"
        @close="$emit('close')"
        @created="$emit('saved', $event)" />
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import DoctorFormComponent from "@/components/Doctor/DoctorFormComponent.vue";
import { Prescriber } from "@/models/Prescriber";

export type PrescriberFormMode = "create" | "edit";

@Component({
    name: "PrescriberFormPanel",
    components: { DoctorFormComponent },
})
export default class PrescriberFormPanel extends Vue {
    @Prop({ required: true }) mode!: PrescriberFormMode;
    @Prop({ default: null }) prescriber!: Prescriber | null;
    @Prop({ default: null }) escriptPrescriber!: Prescriber | null;
    @Prop() buttonTitles!: any;

    get prefill(): Prescriber | null {
        return this.mode === "edit" ? this.prescriber : this.escriptPrescriber;
    }
}
</script>
